import { render, staticRenderFns } from "./LeadsList.vue?vue&type=template&id=1ea9b34a&"
import script from "./LeadsList.vue?vue&type=script&lang=ts&"
export * from "./LeadsList.vue?vue&type=script&lang=ts&"
import style0 from "./LeadsList.vue?vue&type=style&index=0&id=1ea9b34a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports